export const PATH = {
  login: "/login",
  redirect: "/oauth/kakao",
  redirect_apple: "/oauth/apple",
  waiting: "/waiting",
  onboarding: "/onboarding/:id",
  logout: "/logout",
  home: "/",
  survey: "/survey",
  payment: "/payment",
  paymentSuccess: "/payment/success",
  paymentFail: "/payment/fail",

  steppayPaymentSuccess: "/payment/steppay/success",
  steppayPaymentFail: "/payment/steppay/fail",
  steppayManagement: "/payment/management",
};
